// extracted by mini-css-extract-plugin
export var body = "_o9-8";
export var button = "_o9-0";
export var closeButton = "_o9-5";
export var content = "_o9-3";
export var empty = "_o9-f";
export var grid = "_o9-c";
export var header = "_o9-4";
export var icon = "_o9-1";
export var option = "_o9-d";
export var optionSelected = "_o9-e";
export var overlay = "_o9-2";
export var searchIcon = "_o9-a";
export var searchInput = "_o9-b";
export var searchWrapper = "_o9-9";
export var title = "_o9-6";
export var visuallyHidden = "_o9-7";